import { HasDependencies } from './types';

export interface LocalStorageService<T> {
  get: () => T | null;
  set: (key: T) => void;
  clear: () => void;
}

export class DefaultLocalStorageService<T = string>
  implements LocalStorageService<T>, HasDependencies
{
  constructor(private readonly key: string) {}

  getDeps = (): (string | undefined)[] => [];

  get = (): T | null => {
    return localStorage.getItem(this.key) as T | null;
  };

  set = (value: T) => {
    localStorage.setItem(this.key, value as string);
  };

  clear = () => {
    localStorage.removeItem(this.key);
  };
}

export class JsonLocalStorageService<T>
  implements LocalStorageService<T>, HasDependencies
{
  constructor(
    private readonly key: string,
    private readonly reviver?: (key: string, value: any) => any
  ) {}

  getDeps = (): (string | undefined)[] => [];

  get = (): T | null => {
    const item = localStorage.getItem(this.key);
    if (!item) {
      return null;
    }
    return JSON.parse(item, this.reviver) as unknown as T;
  };

  set = (value: T) => {
    localStorage.setItem(this.key, JSON.stringify(value));
  };

  clear = () => {
    localStorage.removeItem(this.key);
  };
}
